'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

type CardHeaderProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

export const CardHeader = ({ children, ...props }: CardHeaderProps) => {
  return <div {...props}>{children}</div>;
};
